export default __webpack_public_path__ + "static/media/settings.509594f4.svg";